import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { UtilService } from "src/app/services/util.service";
import { SidebarService } from "../../services/sidebar.service";
import { UserRole } from "src/app/models/user";

export interface AccountType {
  id: number,
  value: string
}

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    standalone: false
})
export class RegisterComponent {
  UserRole: typeof UserRole = UserRole;
  accountTypes: AccountType[] = [
    { id: UserRole.Protester, value: 'PROTESTER/INTERVENOR' },
    { id: UserRole.Agency_Attorney, value: 'AGENCY REPRESENTATIVE' }
  ];
  selectedAccountType: AccountType = this.accountTypes[0];
  constructor(private sidebarService: SidebarService, private router: Router, public dialogRef: MatDialogRef<RegisterComponent>, private util: UtilService) { }

  onOk() {
    let selectedAccountTypeId = this.selectedAccountType?.id;
    console.log("selectedAccountTypeId ::" ,selectedAccountTypeId);
    if(selectedAccountTypeId === UserRole.Agency_Attorney){

      this.util.displayDialogMessage('Warning', "By registering for an account as a representative of the U.S. Government, you are representing" +
        " that you are an officer, employee, or authorized agent acting under the authority of the United" +
        " States or a department, agency, or officer thereof. Falsely assuming or pretending to be an officer" +
        " or employee acting under the authority of the United States or a department, agency, or officer" +
        " thereof may be punishable by a fine and/or imprisonment pursuant to 18 U.S.C. § 912. GAO will" +
        " refer any suspected misrepresentations regarding a User’s status to the appropriate authorities.",
        {confirmText: "OK", cancelBtn: true}).pipe()
        .subscribe(res => {
          if (res) {
            this.router.navigate(['/register/' + selectedAccountTypeId]);
          }
        });
    } else {
      this.router.navigate(['/register/' + selectedAccountTypeId]);
    }
    this.dialogRef.close();
  }

  onCancel(): void {
    this.dialogRef.close();
  }


}
